import { TextareaHTMLAttributes } from 'react'

import s from './AdminTextArea.module.scss'

interface AdminTextAreaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  label?: string
  labelSize?: string
  labelWeight?: number
  onChange: (value: string) => void
}

export const AdminTextArea = ({ value, label, labelSize, labelWeight, onChange, ...props }: AdminTextAreaProps) => {
  return (
    <label>
      <span style={{ fontSize: labelSize || '18px', fontWeight: labelWeight || 400 }}>{label}</span>

      <textarea
        className={s.textArea}
        value={value}
        onChange={(e: any) => onChange!(e.target.value)}
        rows={10}
        {...props}
      ></textarea>
    </label>
  )
}
